// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"125":"fb681e3937e20c1c0d38","293":"7be8ecc8412ac4e17ba9","413":"19c3f038e2058f816f4b"}[chunkId] + ".js";
};